export default class QAOptionsUtils {

    static getQueryOption = (name = null) => {
        const params = (new URL(document.location)).searchParams;
        const value = params.get(name);
        return value;
    }
}

